import { Routes } from '@angular/router';
import { MainPageComponent } from '@app/pages';
import { HomeComponent } from '@app/pages/main-page/home/home.component';
import { PdfMenuPagesComponent } from '@app/pages/main-page/pdf-menu-pages/pdf-menu-pages.component';
import { pdfMenuResolvers } from '@app/pages/main-page/pdf-menu-pages/pdf-menu-pages.resolvers';
import { DynamicComponent } from '@app/pages/main-page/dynamic/dynamic.component';
import { pageResolvers } from '@app/pages/main-page/dynamic/dynamic.resolvers';
import { PreferencesComponent } from '@app/pages/main-page/preferences/preferences.component';
import { SpecialOfferComponent } from '@app/pages/main-page/special-offer/special-offer.component';

export const appRoutes: Routes = [
  {
    path: 'main',
    component: MainPageComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        component: HomeComponent,
        data: { animation: 'Home', screen: 'Home' },
      },
      {
        path: 'preferences',
        component: PreferencesComponent,
        data: { animation: 'Preferences', screen: 'Preferences' },
      },
      {
        path: 'special-offer',
        component: SpecialOfferComponent,
        data: { animation: 'SpecialOffer', screen: 'SpecialOffer' },
      },
      {
        path: 'pdf-menu/:id',
        component: PdfMenuPagesComponent,
        resolve: pdfMenuResolvers,
      },
      {
        path: 'page/:id',
        component: DynamicComponent,
        resolve: pageResolvers,
      },
    ],
  },
];
